/**
 * @generated SignedSource<<4c81449dc4a87c752ee9740daa15ad7d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type ProductConfigurationStatus = "COMPLETE" | "NONE" | "PARTIAL";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type ZakekeEnvironment = "AI_STUDIO" | "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type productSidePanelContent_ProductQuery$variables = {
  id: string;
  skipProductAreaBackgroundRules: boolean;
  skipProductMoqRules: boolean;
  skipProductPrintTypes: boolean;
  skipProductQuoteRule: boolean;
  skipProductScenes: boolean;
};
export type productSidePanelContent_ProductQuery$data = {
  readonly model: {
    readonly additionalCodes: ReadonlyArray<{
      readonly code: string;
      readonly merchantProductName: string;
      readonly salesChannel: {
        readonly detail: {
          readonly id: string;
          readonly properties: {
            readonly name: string | null;
            readonly storePosition: number | null;
          } | null;
        } | null;
        readonly ecommerceSettings: {
          readonly definitiveUrl: string | null;
          readonly ecommerceName: ECommerce;
          readonly hasProductsApi: boolean;
          readonly productsApi: string | null;
          readonly remoteUrl: string | null;
        } | null;
        readonly id: string;
      };
      readonly salesChannelID: string;
    }>;
    readonly areaBackgroundRules?: {
      readonly printTypeRule: ReadonlyArray<{
        readonly key: number;
        readonly value: {
          readonly ruleID: number;
        };
      }> | null;
      readonly productRule: {
        readonly colorList: string | null;
      } | null;
    } | null;
    readonly canAddAdditionalCode: boolean;
    readonly code: string;
    readonly configurationStatus: ProductConfigurationStatus;
    readonly id: string;
    readonly modelColorsCompressed: string;
    readonly modelID: number;
    readonly moqRules?: {
      readonly printTypeRules: ReadonlyArray<{
        readonly key: number;
        readonly value: {
          readonly moqRuleID: number;
          readonly name: string;
        };
      }> | null;
      readonly productRule: {
        readonly id: string;
        readonly moqRuleID: number;
        readonly name: string;
      } | null;
    } | null;
    readonly name: string;
    readonly printTypes?: ReadonlyArray<{
      readonly name: string;
      readonly printTypeID: number;
      readonly printTypeRestrictions: {
        readonly disableSellerImages: boolean | null;
        readonly disableUserImages: boolean | null;
      } | null;
    }>;
    readonly provider: ProductProvider;
    readonly quoteRule?: {
      readonly allowAddToCart: boolean;
      readonly formControlsData: string | null;
      readonly id: string;
      readonly isValidForAllProducts: boolean;
      readonly name: string | null;
      readonly notifyEmailList: string | null;
      readonly products: ReadonlyArray<number> | null;
      readonly quoteRuleID: number;
    } | null;
    readonly salesChannel: {
      readonly detail: {
        readonly id: string;
        readonly properties: {
          readonly name: string | null;
          readonly storePosition: number | null;
        } | null;
      } | null;
      readonly ecommerceSettings: {
        readonly definitiveUrl: string | null;
        readonly ecommerceName: ECommerce;
        readonly hasProductsApi: boolean;
        readonly productsApi: string | null;
        readonly remoteUrl: string | null;
      } | null;
      readonly id: string;
    };
    readonly scenes?: ReadonlyArray<{
      readonly sceneID: any;
    }>;
    readonly smallImageUrl: string;
    readonly sourceProductTemplateID: number | null;
    readonly statusID: number;
    readonly zakekeEnvironment: ZakekeEnvironment;
  } | null;
  readonly subscription: {
    readonly maxProducts: {
      readonly numPublishedProducts: number | null;
    };
  } | null;
};
export type productSidePanelContent_ProductQuery = {
  response: productSidePanelContent_ProductQuery$data;
  variables: productSidePanelContent_ProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductAreaBackgroundRules"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductMoqRules"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductPrintTypes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductQuoteRule"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductScenes"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelID",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusID",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configurationStatus",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallImageUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zakekeEnvironment",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddAdditionalCode",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceProductTemplateID",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelColorsCompressed",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannelDetail",
  "kind": "LinkedField",
  "name": "detail",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetailProperties",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        (v9/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "storePosition",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productsApi",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasProductsApi",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitiveUrl",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    (v19/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v20/*:: as any*/),
        (v21/*:: as any*/),
        (v22/*:: as any*/),
        (v23/*:: as any*/),
        (v24/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantProductName",
  "storageKey": null
},
v28 = {
  "condition": "skipProductPrintTypes",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelPrintType",
      "kind": "LinkedField",
      "name": "printTypes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "printTypeID",
          "storageKey": null
        },
        (v9/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PartPrintTypeRestriction",
          "kind": "LinkedField",
          "name": "printTypeRestrictions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "disableSellerImages",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "disableUserImages",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v29 = {
  "condition": "skipProductScenes",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelScene",
      "kind": "LinkedField",
      "name": "scenes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sceneID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorList",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ruleID",
  "storageKey": null
},
v33 = {
  "condition": "skipProductQuoteRule",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuoteRule",
      "kind": "LinkedField",
      "name": "quoteRule",
      "plural": false,
      "selections": [
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quoteRuleID",
          "storageKey": null
        },
        (v9/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isValidForAllProducts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formControlsData",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAddToCart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notifyEmailList",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "products",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "moqRuleID",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "MoqRule",
  "kind": "LinkedField",
  "name": "productRule",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    (v34/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "MaxProducts",
  "kind": "LinkedField",
  "name": "maxProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numPublishedProducts",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    (v19/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v20/*:: as any*/),
        (v21/*:: as any*/),
        (v22/*:: as any*/),
        (v23/*:: as any*/),
        (v24/*:: as any*/),
        (v7/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          (v14/*:: as any*/),
          (v15/*:: as any*/),
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v25/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v10/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v25/*:: as any*/)
            ],
            "storageKey": null
          },
          (v28/*:: as any*/),
          (v29/*:: as any*/),
          {
            "condition": "skipProductAreaBackgroundRules",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AreaBackgroundRules",
                "kind": "LinkedField",
                "name": "areaBackgroundRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AreaBackgroundRule",
                    "kind": "LinkedField",
                    "name": "productRule",
                    "plural": false,
                    "selections": [
                      (v30/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyValuePairOfInt64AndAreaBackgroundRule",
                    "kind": "LinkedField",
                    "name": "printTypeRule",
                    "plural": true,
                    "selections": [
                      (v31/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AreaBackgroundRule",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v32/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v33/*:: as any*/),
          {
            "condition": "skipProductMoqRules",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MoqRules",
                "kind": "LinkedField",
                "name": "moqRules",
                "plural": false,
                "selections": [
                  (v35/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyValuePairOfInt64AndMoqRule",
                    "kind": "LinkedField",
                    "name": "printTypeRules",
                    "plural": true,
                    "selections": [
                      (v31/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MoqRule",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v34/*:: as any*/),
                          (v9/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v36/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v3/*:: as any*/),
      (v5/*:: as any*/),
      (v1/*:: as any*/),
      (v4/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_ProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          (v14/*:: as any*/),
          (v15/*:: as any*/),
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v37/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v10/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v37/*:: as any*/)
            ],
            "storageKey": null
          },
          (v28/*:: as any*/),
          (v29/*:: as any*/),
          {
            "condition": "skipProductAreaBackgroundRules",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AreaBackgroundRules",
                "kind": "LinkedField",
                "name": "areaBackgroundRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AreaBackgroundRule",
                    "kind": "LinkedField",
                    "name": "productRule",
                    "plural": false,
                    "selections": [
                      (v30/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyValuePairOfInt64AndAreaBackgroundRule",
                    "kind": "LinkedField",
                    "name": "printTypeRule",
                    "plural": true,
                    "selections": [
                      (v31/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AreaBackgroundRule",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v32/*:: as any*/),
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v33/*:: as any*/),
          {
            "condition": "skipProductMoqRules",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MoqRules",
                "kind": "LinkedField",
                "name": "moqRules",
                "plural": false,
                "selections": [
                  (v35/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyValuePairOfInt64AndMoqRule",
                    "kind": "LinkedField",
                    "name": "printTypeRules",
                    "plural": true,
                    "selections": [
                      (v31/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MoqRule",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v34/*:: as any*/),
                          (v9/*:: as any*/),
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v36/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7e6d9c5b3b4709ea2569c38df79b302d",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ProductQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ProductQuery(\n  $id: ID!\n  $skipProductPrintTypes: Boolean!\n  $skipProductScenes: Boolean!\n  $skipProductAreaBackgroundRules: Boolean!\n  $skipProductQuoteRule: Boolean!\n  $skipProductMoqRules: Boolean!\n) {\n  model(id: $id) {\n    id\n    modelID\n    name\n    code\n    statusID\n    configurationStatus\n    smallImageUrl\n    zakekeEnvironment\n    provider\n    canAddAdditionalCode\n    sourceProductTemplateID\n    modelColorsCompressed\n    salesChannel {\n      id\n      detail {\n        id\n        properties {\n          name\n          storePosition\n        }\n      }\n      ecommerceSettings {\n        ecommerceName\n        remoteUrl\n        productsApi\n        hasProductsApi\n        definitiveUrl\n        id\n      }\n    }\n    additionalCodes {\n      code\n      salesChannelID\n      merchantProductName\n      salesChannel {\n        id\n        detail {\n          id\n          properties {\n            name\n            storePosition\n          }\n        }\n        ecommerceSettings {\n          ecommerceName\n          remoteUrl\n          productsApi\n          hasProductsApi\n          definitiveUrl\n          id\n        }\n      }\n    }\n    printTypes @skip(if: $skipProductPrintTypes) {\n      printTypeID\n      name\n      printTypeRestrictions {\n        disableSellerImages\n        disableUserImages\n      }\n    }\n    scenes @skip(if: $skipProductScenes) {\n      sceneID\n    }\n    areaBackgroundRules @skip(if: $skipProductAreaBackgroundRules) {\n      productRule {\n        colorList\n        id\n      }\n      printTypeRule {\n        key\n        value {\n          ruleID\n          id\n        }\n      }\n    }\n    quoteRule @skip(if: $skipProductQuoteRule) {\n      id\n      quoteRuleID\n      name\n      isValidForAllProducts\n      formControlsData\n      allowAddToCart\n      notifyEmailList\n      products\n    }\n    moqRules @skip(if: $skipProductMoqRules) {\n      productRule {\n        id\n        moqRuleID\n        name\n      }\n      printTypeRules {\n        key\n        value {\n          moqRuleID\n          name\n          id\n        }\n      }\n    }\n  }\n  subscription {\n    maxProducts {\n      numPublishedProducts\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d34cb30819f3a08512d29ba9e3043013";

export default node;
